// ToolBar.tsx
// Copyright (c) 2020 Neomantra Corp

import React, { useState, useEffect, useRef, useContext } from 'react'
import ConsoleView from './ToolBarView'
import DatahubManager from '../../api/DatahubManager'
import { clearTimers, startRequestTimer, startErrorTimer, useStickyState } from './ToolBarSupport'
import { useSelector, useDispatch } from 'react-redux'

import { RootState } from '../../app/rootReducer'
import { addCard, updateCard } from './toolBarSlice'

const ToolBar = () => {
    const cardStack = useSelector((state: RootState) => state.console.cardStack),
        dispatch = useDispatch()

    const [votive, setVotiveState] = useStickyState('wss://data.neomantra.net:50502', 'votiveInstance')
    const [isLoading, setIsLoading] = useState(false)
    const [isConnected, setIsConnected] = useState(false)
    const [errorMsg, setErrorMsg] = useState('')
    const datahubManager = useRef(null)
    const requestTimer = useRef(null)
    const errorTimer = useRef(null)

    const waitForResponseTime = 6000,
        errorMsgTime = 2000

    const setVotive = (votiveArg: any) => {
        setErrorMsg('')
        datahubManager.current.startNewVotive(votiveArg, setIsConnected, onConnectError)
        setVotiveState(votiveArg)
    }

    const makeCardFromMessage = (msg: any) => {
        dispatch(addCard(msg))
        setIsLoading(false)
        clearTimers(requestTimer, errorTimer, setErrorMsg)
        //console.log(`makeCardFromMessage msg  = `, msg)
    }

    const handleSubscribeUpdate = (msg: any) => {
        dispatch(updateCard(msg))
    }

    const onConnectError = (status: any, code: any, reason: any) => {
        clearTimers(requestTimer, errorTimer, setErrorMsg)
        code === 1000 ? null : setErrorMsg(`Connection Error: ${status}`)
    }

    const sendRequest = (evt: any, exchange: string, openClose: string, ticker: string) => {
        if (cardStack.length >= 12) {
            console.log(`Layout is currently limited to 12 cards`)
            return
        }
        datahubManager.current.sendRequest(makeCardFromMessage, `/${exchange}/${openClose}/${ticker}`)
        datahubManager.current.sendSubscribe(handleSubscribeUpdate, `/${exchange}/${openClose}/${ticker}`)
        setIsLoading(true)
        startRequestTimer(requestTimer, errorTimer, setErrorMsg, setIsLoading, waitForResponseTime, errorMsgTime)
    }

    useEffect(() => {
        // window.localStorage.clear()
        datahubManager.current = new DatahubManager()
        datahubManager.current.start(votive, setIsConnected, onConnectError)
        return () => {
            datahubManager.current.close()
        }
    }, [])

    return (
        <div>
            <ConsoleView errorMsg={errorMsg} isLoading={isLoading} isConnected={isConnected} sendRequest={sendRequest} votiveProp={votive} setVotiveProp={setVotive} />
        </div>
    )
}

export default ToolBar
